export default __webpack_public_path__ + "static/media/19.858aaf76.png";